import React from 'react';

const CheckOutAll = () => {
    return (
        <div className='h-screen items-center flex justify-center'>
            <p className='text-2xl font-black text-teal-700 text-center'>Please Checkout Once Item A Time..</p>
        </div>
    );
};

export default CheckOutAll;